<div class="container" [class.mobile]="deviceType === 'mobile'">
  <div class="decoration-line {{ data.type }}"></div>
  <div class="body">
    <div class="header">
      <h2 *ngIf="data.type === 'free'">FREE</h2>
      <h2 *ngIf="data.type === 'paid'">${{ data.price | number }}</h2>
      <div class="subtitle">
        <span *ngIf="data.type === 'free'">included with membership</span>
        <span *ngIf="data.type === 'paid'">One-time payment</span>
      </div>
    </div>
    <div class="content">
      <h6>You'll get...</h6>
      <div class="get-line">
        <ark-icon icon="system-tick" size="small"></ark-icon>
        <div class="text-c">
          <span class="font-bold text-[16px]">{{ data.credits | number }} Points</span>
        </div>
      </div>
      <div class="get-line">
        <ark-icon icon="system-tick" size="small"></ark-icon>
        <div class="text-c">
          <div>Unique Solutions Movement Artwork</div>
        </div>
      </div>
      <div class="get-line" *ngIf="data.multiplier > 0">
        <ark-icon icon="system-tick" size="small"></ark-icon>
        <div class="text-c multi">
          {{ formattedMultiplier }}x points multiplier
          <ark-icon
            icon="system-info"
            size="small"
            color="disabled"
            ngxTippy="Earn x{{
              data.multiplier
            }} rewards for completing in-app activities"
            tippyClassName="typo-body-xsmall"
          ></ark-icon>
        </div>
      </div>
    </div>
    <div class="footer">
      <ark-button
        (click)="purchase()"
        [loading]="purchasing"
        [disabled]="ctaDisabled"
        size="large"
        >{{ ctaText }}</ark-button
      >
    </div>
  </div>
  <div class="ribbon" *ngIf="data.popular"><span>POPULAR</span></div>
  <div
    class="popup"
    [delayClickOutsideInit]="true"
    (clickOutside)="closePopup()"
    *ngIf="popupVisible"
    [@fadeDownAnimation]=""
  >
    <div class="nft-image"></div>
    <div class="nft-content">
      <div class="nft-eyebrow">{{ data.nft.total }} CREATED</div>
      <h5>{{ data.nft.name }} badges</h5>
      <div class="nft-description">{{ data.nft.description }}</div>
      <div class="learnMore" (click)="gotoDocs()">
        <span>Learn more</span>
        <ark-icon
          icon="system-external-link"
          color="dark"
          size="small"
        ></ark-icon>
      </div>
    </div>
  </div>
</div>
